import Change3DSMethod from './Change3DSMethod';

export default Change3DSMethod;